import { useRef } from 'react';

import { ButtonType } from '@xemplo/button';
import { HeaderIconMode, HeaderIconSize } from '@xemplo/header-icon';
import { DawnPeopleTick } from '@xemplo/icons';
import { Modal, ModalDialogSlot } from '@xemplo/modal-dialog';

import { CancelPrompt } from './cancel-prompt';
import {
  CreatePayrunApprovalDialogRef,
  CreatePayrunApprovalModalProps,
} from './create-payrun-approvers-form.types';
import { ModalBody } from './modal-body';

export const PayrunApprovalModal = (props: Readonly<CreatePayrunApprovalModalProps>) => {
  const { isOpen, dialogProps, onSuccess, handleSubmit, cancelCallback, errorMessage } =
    props;

  const cancelDialogRef = useRef<CreatePayrunApprovalDialogRef>(null);

  const openCancelModal = () => {
    cancelDialogRef.current?.openModalDialog();
  };

  return (
    <>
      <Modal.Dialog {...dialogProps}>
        {isOpen ? (
          <Modal>
            <Modal.Slot
              name={ModalDialogSlot.CloseButton}
              render={
                <Modal.CloseButton
                  onClick={openCancelModal}
                  id="payrun-approver-modal-close-button"
                  ariaLabel="close button"
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Header}
              render={
                <Modal.Header
                  title="New Approver"
                  headerIcon={{
                    icon: <DawnPeopleTick />,
                    mode: HeaderIconMode.AdminActionItem,
                    size: HeaderIconSize.Size56,
                  }}
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Body}
              render={
                <Modal.Body>
                  <ModalBody
                    onSuccess={onSuccess}
                    companyId={props.companyId}
                    errorMessage={errorMessage}
                  />
                </Modal.Body>
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Footer}
              render={
                <Modal.Footer
                  btnPrimary={{
                    onClickAsync: handleSubmit,
                    label: 'Save',
                    ariaLabel: 'Save',
                    type: ButtonType.Primary,
                  }}
                  btnTertiary={{
                    onClick: openCancelModal,
                    label: 'Cancel',
                    ariaLabel: 'Cancel',
                    type: ButtonType.Tertiary,
                  }}
                />
              }
            />
          </Modal>
        ) : null}
      </Modal.Dialog>
      {isOpen ? (
        <CancelPrompt ref={cancelDialogRef} confirmCallback={cancelCallback} />
      ) : null}
    </>
  );
};
